import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import router from '../../router'
const state = {
  authenticated: false,
  userInfo: {
     userId: undefined,
     userName: undefined,
     login: undefined,
     contractIds: {},
     bounds: ''
  }
}

const mutations = {
  set(state, {type, items}) {
      state[type] = items
    }
}

const actions = {
    logout({ commit }) {
    return new Promise((resolve, reject) => {
      // Do something here... lets say, a http call using vue-resource
      Vue.http.get('php_scripts/logout.php').then(res => {
         // http success, call the mutator and change something in state
        commit('set', {type: 'userInfo', items: { 'userId': undefined, 'login': undefined, 'userName': undefined, 'contractIds': {},'bounds': []}})
        commit('set', {type: 'authenticated', items: false })
        resolve(res) // Let the calling function know that http is done. You may send some data back
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    })
  },
  checkSession({ commit }) {
    return new Promise((resolve, reject) => {
      // Do something here... lets say, a http call using vue-resource
      Vue.http.get('php_scripts/check_auth.php').then(res => {
         // http success, call the mutator and change something in state
        commit('set', {type: 'userInfo', items: { 'userId': res.data.user_id, 'login': res.data.login, 'userName': res.data.user_name, 'contractIds': res.data.contract_ids,'bounds': res.data.bounds}})
        commit('set', {type: 'authenticated', items: (res.data.user_id > 0)})
        resolve(res) // Let the calling function know that http is done. You may send some data back
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    })
  },
  signin({ commit }, { loginValue, passwordValue, rememberValue}) {
    return new Promise((resolve, reject) => {
      // Do something here... lets say, a http call using vue-resource
      Vue.http.post('php_scripts/auth.php', { loginValue, passwordValue, rememberValue}, { emulateJSON: true }).then(res => {
         // http success, call the mutator and change something in state
        commit('set', {type: 'userInfo', items: { 'userId': res.data.user_id, 'login': res.data.login, 'userName': res.data.user_name, 'contractIds': res.data.contract_ids,'bounds': res.data.bounds}})
        commit('set', {type: 'authenticated', items: (res.data.user_id > 0)})
        router.go(-1)
        resolve(res) // Let the calling function know that http is done. You may send some data back
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    })
  },
  auth ({ commit }, { loginValue, passwordValue, rememberValue}) {
    Vue.http.post('php_scripts/auth.php', {loginValue, passwordValue, rememberValue}, { emulateJSON: true }).then((res) => {
      console.log(res.data)
      commit('set', {type: 'userInfo', items: { 'userId': res.data.user_id, 'login': res.data.login, 'userName': res.data.user_name}})
      commit('set', {type: 'authenticated', items: (res.data.user_id > 0)})
      router.push('/cabinet')
      //state.userInfo.userId = res.data.user_id
      //state.userInfo.login = res.data.login
    }).catch((err) => {
      console.log(err)
    })
  }
}

const getters = {
  userInfo(state) {
    return state.userInfo
  },
  authenticated(state) {
    return state.authenticated
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}